var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueFragment',[_c('HomeBanner'),_c('AboutMeSnippet')],1)}
var staticRenderFns = []

export { render, staticRenderFns }